import UserModel from 'src/models/UserModel';
import { createTokenStore } from './tokenStore';

const { getToken, clearToken } = createTokenStore({
  getExchangeUrl: () => '/paypal/token/exchange',
  getParseToken: () => UserModel.getInstance().sessionToken
});

export const getPaypalToken = getToken;
export const clearPaypalToken = clearToken;
